import { useProposedSolutionCards, useSound } from "../../../hooks";
import { PlayersSolutionCardsMolecule, Tipping } from "../../molecules";
import goldenCoinForCelebration from "../../../assets/coins/goldenCoinForCelebration.svg";
import { useContext } from "react";
import { SocketContext, TeamContext, UserContext } from "../../../context";

const ProposedSolutionCardsFullScreen = () => {
    const { game } = useContext(TeamContext); 
    const { tipPlayerSocketEmit } = useContext(SocketContext);
    const { userData } = useContext(UserContext);
    const [proposedSolutionCardsArray] = useProposedSolutionCards();
    const {playSound} = useSound();

    const likeTheSolution = (tippedUserEmail: string) => {
        if(!tippedUserEmail) return;
        tipPlayerSocketEmit(tippedUserEmail);
    }

    return (
        <div className="proposed_solution_cards_full_screen_wrapper">
            {proposedSolutionCardsArray.map((solutionCard: any, index: number) => {

                const cardDimentions = {width: `22vh`, height: `29vh`};

                if (!solutionCard) return <div></div>

                return (
                    <div className="proposed_solution_cards_full_screen_and_number_wrapper" key={index}>
                        <div className="proposed_solution_cards_full_screen_number center_horizontally_and_vertically">
                            <div className={`proposed_solution_cards_full_screen_number_box ${"user_color_"+solutionCard.player.color} center_horizontally_and_vertically`}> {index+1} </div>
                            <div className="proposed_solution_cards_full_screen_name"> {solutionCard.player.nickname} </div>
                        </div>
                        <div className="proposed_solution_cards_full_screen" onMouseEnter={() =>playSound("/sounds/ItemHover.mp3")}>
                            <PlayersSolutionCardsMolecule selectedCard={solutionCard} cardDimentions={cardDimentions} proposedCardOrder={index+1} fullScreenIsOn={true} />
                        </div>
                        <div className={`proposed_solution_cards_full_screen_tipping_wrapper center_horizontally_and_vertically`} >
                            <div onClick={() => likeTheSolution(solutionCard?.player?.email)}>
                                <div className={`proposed_solution_cards_full_screen_tipping_heart center_horizontally_and_vertically ${solutionCard?.player?.email === userData?.email && "disabled_area"} `} >
                                    {game?.gameInfo.players[solutionCard.player.email]?.tipped[userData?.email || ""] ?
                                        <div></div>
                                        :
                                        <img className="proposed_solution_cards_full_screen_tipping_heart_coin" src={goldenCoinForCelebration} alt="golden coin" />
                                    }
                                </div>
                            </div>

                            <Tipping solutionCardUserEmail={solutionCard.player.email} />

                        </div>
                    </div>
                )
            })}
        </div>
    );
}

export default ProposedSolutionCardsFullScreen;